/** Access level for the settings string */
export var EncryptionLevel;
(function (EncryptionLevel) {
    /** Full access to the settings string */
    EncryptionLevel[EncryptionLevel["None"] = 0] = "None";
    /** Only support users are allowed to view the settings contents */
    EncryptionLevel[EncryptionLevel["Support"] = 1] = "Support";
    /** Only admin users are allowed to view the settings contents */
    EncryptionLevel[EncryptionLevel["Admin"] = 2] = "Admin";
    /** Never show the settings contents */
    EncryptionLevel[EncryptionLevel["NeverDisplay"] = 3] = "NeverDisplay";
})(EncryptionLevel || (EncryptionLevel = {}));
